import { css } from '@emotion/core'

export default {
  qualityTags: css`
    padding: 0px;
  `,
  commentChips: css`
    margin-inline-end: 5px;
    padding-bottom: 4px;
  `,
}
